import { BrandThemeTokens } from './types';

export const listacasamentoTheme: BrandThemeTokens = {
  palette: {
    primaryMain: '#d4af37',
    secondaryMain: '#8b4513',
    backgroundDefault: '#faf7f0',
    surface: '#ffffff',
    surfaceAlt: '#fef8ee',
    textPrimary: '#2e2a24',
    textSecondary: '#6f665c',
    heroGradientStart: '#fff7e6',
    heroGradientEnd: '#f0e2be',
    heroGlow: 'rgba(212, 175, 55, 0.24)',
    borderSoft: 'rgba(0,0,0,0.08)',
  },
  typography: {
    fontFamily: '"Playfair Display", "Georgia", serif',
    headingFontFamily: '"Playfair Display", "Georgia", serif',
    bodyFontFamily: '"Playfair Display", "Georgia", serif',
    headingWeight: 600,
    bodyWeight: 400,
    buttonWeight: 700,
  },
};
